import React, { FC } from 'react';
import AngleButton from '../AngleButton';

interface Props {
  title: string;
  body: string;
  link?: string;
}

const QuestionBox: FC<Props> = ({ title, body, link }) => {
  return (
    <div className='p-4 mt-6 text-left border border-gray-10'>
      <h4 className='group-header'>{title}</h4>
      <div className='mt-3 body-paragraph' dangerouslySetInnerHTML={{ __html: body }}></div>
      {link && (
        <div className='mt-3'>
          <AngleButton text='Read more' link={link} />
        </div>
      )}
    </div>
  );
};

export default QuestionBox;
